import { isElementType } from '@lumapps/wrex/slate/utils/isElementType';

import { Image } from '../components/blocks/Image';

export const isImage = isElementType(Image);
